import "./Loader.css";

interface LoaderProps {
}
const Loader: React.FC<LoaderProps> = ({}) => {
    return <div className="ms_lms_loader"></div>
}
export default Loader;
